import {useState} from 'react';
import {useIntl} from 'react-intl';
import {useNavigate} from 'react-router-dom';
import {
  PlusIcon,
  QueueListIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline';

import Button from '../../../../components/Button';
import PageHeader from '../../../../components/_layouts/PageHeader';

import HomeList from './HomeList';
import HomeGrid from './HomeGrid';

const JobLocationPage = () => {
  const {formatMessage} = useIntl();
  const navigate = useNavigate();

  const [formatContent, setFormatContent] = useState('list');

  return (
    <>
      <PageHeader
        title={formatMessage({id: 'job-location'})}
        breadcrumbs={[
          {
            id: 'job-location',
            label: formatMessage({id: 'job-location'}),
          },
          {
            id: 'job-location-home',
            label: formatMessage({id: 'home'}),
          },
        ]}
        rightContent={
          <Button
            extraClassName="shadow-sm"
            onClick={() => navigate('/job-location/new')}>
            <>
              <PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
              {formatMessage({id: 'new-jobLocation'})}
            </>
          </Button>
        }
      />
      <div className="flex items-center gap-2 mb-4">
        <Button
          variant={formatContent === 'list' ? 'primary' : 'secondary'}
          onClick={() => setFormatContent('list')}>
          <>
            <QueueListIcon className="mr-2 h-5 w-5" aria-hidden="true" />
            {formatMessage({id: 'list'})}
          </>
        </Button>
        <Button
          variant={formatContent === 'grid' ? 'primary' : 'secondary'}
          onClick={() => setFormatContent('grid')}>
          <>
            <Squares2X2Icon className="mr-2 h-5 w-5" aria-hidden="true" />
            Grid
          </>
        </Button>
      </div>
      {formatContent === 'list' ? <HomeList /> : <HomeGrid />}
    </>
  );
};

export default JobLocationPage;
